module.exports = __webpack_public_path__ + "static/media/Avatars_Female_New-13.f4f67469.jpg";